const CtaSection = () => {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20dark%20archive%20corridor%20with%20endless%20shelves%20of%20labelled%20boxes%20receding%20into%20warm%20amber%20light%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20strong%20perspective%20and%20depth%2C%20high%20detail&width=1700&height=760&seq=hl-cta-01&orientation=landscape"
        alt="黑料看料存档留档档案库通道"
        title="黑料看料 · 存档留档持续推进"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90" />

      <div className="relative mx-auto w-full max-w-[1240px] px-4 md:px-6 py-16 md:py-24 text-center">
        <span className="reveal inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-4 py-1.5 text-xs tracking-[0.2em] text-accent-300">
          <i className="ri-links-line" />
          存档 · 留档 · 备份
        </span>
        <h2 className="reveal mx-auto mt-6 max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
          重要的留档记录，值得被完整地保存下来
        </h2>
        <p className="reveal mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
          先浏览存档总览，了解留档批次与备份方式，再按时间或人物检索过往存证与底稿，随时回看不丢失。
        </p>
        <div className="reveal mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#archive"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            <i className="ri-archive-line" />
            浏览存档总览
          </a>
          <a
            href="#trust"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 bg-background-50/5 px-7 py-3.5 text-sm font-medium text-background-100 backdrop-blur-sm transition-colors hover:bg-background-50/10 sm:w-auto cursor-pointer"
          >
            <i className="ri-shield-check-line" />
            查看备份承诺
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;